import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Route} from "react-router-dom";
import {Routes} from "react-router";

// Screens
import {
  Login,
  Main,
  Inicio,
  Publicacao,
  PublicacaoEdit,
  Notificacao,
  NotificacaoEdit,
  Ci,
  CiCreate,
  User,
  UserEdit,
  UserSenha,
  NotFound, BancoHorasCreate, BancoHoras
} from "./screens";

const root = createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="portalcolaborador" element={<App/>}>
        <Route path="login" element={<Login/>}/>
        <Route element={<Main/>}>
          <Route path="inicio" element={<Inicio/>}/>
          <Route path="load"/>

          <Route path="publicacao" element={<Publicacao/>}/>
          <Route path="publicacao/edit" element={<PublicacaoEdit/>}/>

          <Route path="notificacao" element={<Notificacao/>}/>
          <Route path="notificacao/edit" element={<NotificacaoEdit/>}/>

          <Route path="comunicacaointerna" element={<Ci/>}/>
          <Route path="comunicacaointerna/edit" element={<CiCreate/>}/>

          <Route path="bancodehoras" element={<BancoHoras/>}/>
          <Route path="bancodehoras/edit" element={<BancoHorasCreate/>}/>

          <Route path="user" element={<User/>}/>
          <Route path="user/edit" element={<UserEdit/>}/>
          <Route path="user/senha" element={<UserSenha/>}/>
        </Route>
      </Route>
      <Route path="*" element={<NotFound/>}/>
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
